import { Box, Typography } from "@mui/material"
import AppWidget from "minimals-template/pages/sections/@dashboard/general/app/AppWidget"
import WidgetCard from "lib/widget-card"

export function ProjectBridgeStatCard({ title, total, color = "primary", percent }) {
    if (typeof percent === "number") {
        return (
            <AppWidget
                title={title}
                total={total}
                color={color}
                chartData={{ series: [clampPercent(percent)] }}
                sx={{ flex: 1, minWidth: 260, minHeight: 140 }}
            />
        )
    }

    return (
        <WidgetCard bannerColor={`${color}.main`} sx={{ flex: 1, minWidth: 260, minHeight: 140 }}>
            <Box sx={{ color: "text.primary" }}>
                <Typography className="title" variant="body2">
                    {title}
                </Typography>
                <Typography variant="h4" className="number" data-cy="project-bridge-stat-card-total">
                    {total}
                </Typography>
            </Box>
        </WidgetCard>
    )
}

function clampPercent(value) {
    return Math.max(0, Math.min(100, Number(value || 0)))
}
